import { lazy, Suspense } from 'react';
import { APP_MODE } from '../config';
import type { ComponentType } from 'react';

/**
 * Beranda = dashboard (ui-context.md layar 1).
 *
 * Mode A (`community`) menampilkan dashboard laporan warga; Mode B (`bmkg`)
 * menampilkan dashboard data BMKG (CP10): gempa, peringatan dini, prakiraan.
 *
 * CP12: kode dashboard (modul data + validasi zod) bertahap — chunk halaman
 * dimuat sebelum shell interaktif, satu-satunya aturan agar LCP anggaran
 * tetap untuk peta/teks yang paling dibutuhkan.
 */
const DashboardPage = lazy(() =>
  import('./DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
const BmkgDashboardPage = lazy(() =>
  import('./BmkgDashboardPage').then((m) => ({ default: m.BmkgDashboardPage })),
);

const PAGE_FOR_MODE: Record<string, ComponentType> = {
  community: DashboardPage,
  bmkg: BmkgDashboardPage,
};

export function HomePage() {
  const Dashboard = PAGE_FOR_MODE[APP_MODE] ?? DashboardPage;
  return (
    <Suspense
      fallback={
        <p role="status" className="route-loading">
          Memuat dashboard…
        </p>
      }
    >
      <Dashboard />
    </Suspense>
  );
}
